import * as React from 'react';
import { Label } from '@cian/ui-kit';
import * as styles from './PromoSnippetLabels.css';

interface IPromoSnippetLabelsProps {
  showReliableFlag: boolean;
  isSalesLeader: boolean;
}

export function PromoSnippetLabels({ showReliableFlag, isSalesLeader }: IPromoSnippetLabelsProps) {
  return (
    <>
      {showReliableFlag && (
        <span className={styles.label} data-testid="reliable">
          <Label background="primary_10" color="primary_100">
            Надежный ЖК
          </Label>
        </span>
      )}
      {isSalesLeader && (
        <span className={styles.label} data-testid="salesLeader">
          <Label background="gray10_100" color="black_100">
            Лидер продаж
          </Label>
        </span>
      )}
    </>
  );
}
